{
  "main": {
    "title": "Flight Task",
    "nazaj": "Back"
  },
  "labels": {
    "datum": "Date:",
    "pilot": "Select pilot:",
    "reg": "Aircraft registration:",
    "tip": "Aircraft type:",
    "licenca": "License:",
    "ruta": "Route:",
    "namen": "Purpose:",
    "potnik": "Passenger name and surname:"
  },
  "buttons": {
    "posljiOdobritev": "Send task for approval",
    "dodajPotnika": "Add passenger",
    "brisiIzbiro": "Clear selection"
  },
  "obvestila": {
    "zapisDodan": "Record successfully added.",
    "napakaVnosa": "Data entry error.",
    "napakaInputa": "Some required information is missing; please review and complete the form.",
    "napakaBranja": "Error reading data.",
    "vprasanjeBrisa": "Do you really want to delete the passenger?",
    "napakaPosiljanja": "Sending error",
    "uspesnoPoslan": "Flight task successfully submitted!"
  }
}